export default "__VITE_ASSET__rDSByblH__"